import PropTypes from "prop-types";
import ErrorMessage from "../Errors/ErrorMessage";
import { useFormikContext } from "formik";

const Text = ({
  title,
  name,
  className,
  containerClass = "",
  serverError,
  formikOnChange = true,
  onChange,
  showPassword,
}) => {
  const { errors, handleChange, values } = useFormikContext();
  return (
    <div className={`form-group ${containerClass}`}>
      <label className='f-13 text-dark text-left d-flex flex-row justify-content-start'>
        {title}
      </label>
      <input
        type={showPassword ? "text" : "password"}
        name={name}
        value={values[name]}
        onChange={
          formikOnChange ? handleChange : (e) => onChange(e.target.value)
        }
        className={`form-control ${className}`}
      />
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};

Text.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  containerClass: PropTypes.string,
  serverError: PropTypes.any,
  formikOnChange: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Text;
